import request from '@/utils/request';
const API_URL: string = '/Person'

export function person(uesMethod: string, params: ParamsInfo | null, data: number[] | DataInfo | null | any[], funName: string = '') {
  return request({
    url: API_URL + funName,
    method: uesMethod,
    params,
    data
  });
}

export interface DataInfo {
  id?: number
  name?: string
  openId?: string
  departmentId?: any
  departments?: any
  position?: string
  telephone?: string
  nickName?: string
  imgUrl?: string
  authUser?: object
}

export interface ParamsInfo {
  pageNum?: number
  pageSize?: number
  organizationId?: number
  nickName?: string
  departmentId?: any
  openId?: string
  telephone?: string
  name?: string
  position?: any
  projectId?: number
  isSubscribe?: any
}
